import { Component, OnInit, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { LocalizationService } from '../../core/localization/localization.service';
import { AinPageComponent } from '../../shared/design-system/page.component';
import { AinStateComponent } from '../../shared/design-system/state.component';
import { CatalogService, HospitalityProperty } from './catalog.service';

@Component({
  standalone: true,
  selector: 'ain-hospitality-properties',
  imports: [AinPageComponent, AinStateComponent, TableModule, ButtonModule],
  template: `
    <ain-page [title]="t('catalog.hospitality.properties.title')" [description]="t('catalog.hospitality.properties.description')">
      @if (loading()) {
        <ain-state type="loading" [title]="t('catalog.loading')" />
      } @else {
        <section class="panel">
          <div class="toolbar">
            <button pButton type="button" [label]="t('catalog.action.create')" (click)="openCreate()"></button>
            <button pButton type="button" [label]="t('catalog.action.refresh')" severity="secondary" (click)="load()"></button>
          </div>
          <p-table [value]="rows()" [paginator]="true" [rows]="15">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 3rem"><input type="checkbox" aria-label="select all" /></th>
                <th>{{ t('catalog.hospitality.propertyCode') }}</th>
                <th>{{ t('catalog.hospitality.propertyName') }}</th>
                <th>{{ t('catalog.hospitality.address') }}</th>
                <th>{{ t('catalog.tracking.status') }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td><input type="checkbox" [attr.aria-label]="row.propertyCode" /></td>
                <td><button type="button" class="link-btn" (click)="openDetail(row.id)">{{ row.propertyCode }}</button></td>
                <td>{{ row.name }}</td>
                <td>{{ row.address }}</td>
                <td>{{ row.isActive ? t('catalog.hospitality.active') : t('catalog.hospitality.inactive') }}</td>
              </tr>
            </ng-template>
          </p-table>
        </section>
      }
    </ain-page>
  `,
  styles: [`
    .panel { display: grid; gap: 10px; }
    .toolbar { display: flex; gap: 8px; }
    .link-btn { border: 0; background: none; color: #1d4ed8; cursor: pointer; font-weight: 600; padding: 0; }
  `]
})
export class HospitalityPropertiesComponent implements OnInit {
  private readonly service = inject(CatalogService);
  private readonly router = inject(Router);
  private readonly localization = inject(LocalizationService);

  readonly loading = signal(true);
  readonly rows = signal<HospitalityProperty[]>([]);

  ngOnInit(): void { this.load(); }

  load(): void {
    this.loading.set(true);
    this.service.listHospitalityProperties().subscribe({
      next: rows => { this.rows.set(rows); this.loading.set(false); },
      error: () => { this.rows.set([]); this.loading.set(false); }
    });
  }

  openDetail(id: string): void { void this.router.navigate(['/hospitality/properties', id]); }
  openCreate(): void { void this.router.navigate(['/hospitality/properties', 'new']); }

  t(key: string): string { return this.localization.translate(key); }
}
